import Marquee from "react-fast-marquee";

const ITEMS = [
    "Lawn Care",
    "Gutter Cleaning",
    "Window Cleaning",
    "Junk Removal",
    "Locally Owned — Adelaide SA",
    "Multiple Services, One Booking",
];

export const EditorialMarquee = () => (
    <div data-testid="editorial-marquee" className="border-y border-forest/10 bg-forest py-4 text-bone">
        <Marquee speed={35} gradient={false} pauseOnHover>
            {ITEMS.map((item) => (
                <span key={item} className="mx-8 flex items-center gap-8 font-mono text-xs uppercase tracking-[0.25em]">
                    {item}
                    <span className="text-ochre">•</span>
                </span>
            ))}
        </Marquee>
    </div>
);
